import { Component, ElementRef, Input, OnInit } from '@angular/core';

import { Tutorial, TutorialItem, TutorialItemGallery } from './tutorial.interface';
import { CommonModule } from '@angular/common';
import { ComponentHeaderComponent } from '../component-header/component-header.component';
import { MediaGalleryComponent } from '../media-gallery/media-gallery.component';
import { GenericTextComponent } from '../generic-text/generic-text.component';
import { HasTextPipe } from '@finder/shared/utils/pipes/has-text/has-text.pipe';
import { PolylineComponent } from '../polyline/polyline.component';
import { IsMeMediaPipe } from '@finder/shared/utils/pipes/is-me-media/is-me-media.pipe';
import { IsVideoPipe } from '@finder/shared/utils/pipes/is-video/is-video.pipe';
import { PictureComponent } from '../picture/picture.component';
import { ScrollToDirective } from '@finder/shared/directives/scroll-to/scroll-to.directive';
import { MultipleItemsPerRowDirective } from '@finder/shared/directives/multiple-items-per-row/multiple-items-per-row.directive';
@Component({
    selector: 'finder-tutorial',
    templateUrl: './tutorial.component.html',
    styleUrls: ['./tutorial.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        ComponentHeaderComponent,
        GenericTextComponent,
        HasTextPipe, // hasText
        IsMeMediaPipe, // isMeMedia
        IsVideoPipe, // isVideo
        MediaGalleryComponent,
        MultipleItemsPerRowDirective, // finderMultipleItemsPerRow
        PictureComponent,
        PolylineComponent,
        ScrollToDirective, // finderScrollTo
    ]
})
export class TutorialComponent implements OnInit {
    @Input() data: Tutorial;

    constructor(
        private el: ElementRef,
    ) {}

    ngOnInit() {
        if (!this.data || !this.data.items) {
            return;
        }

        this.prepGallery();
    }

    private prepGallery() {
        this.data.items.forEach((item: TutorialItem) => {
            const config: TutorialItemGallery = this.getConfig(item);

            // Hide controls if set in CMS
            if (item.controls === false) {
                // Hide controls
                config.controls.video.display = 'hide';
                config.controls.video.playIconOverlay = void 0;
            }

            if (item.playButton === false) {
                config.controls.video.playIconOverlay = void 0;
            }

            item.gallery = config;
            item.gallery.media = item.media;
            if (this.data.enableFullscreen) {
                item.gallery.callbacks = item.gallery.callbacks || {};
            }
        });

        // Check for width constraint
        if (this.data.width) {
            this.el.nativeElement.style.setProperty('--tutorial-item-max-width', this.data.width);
        }
    }

    private getConfig(item: TutorialItem): TutorialItemGallery {
        return {
            layout: ['slides', 'controls', 'tabs', 'thumbnails'],
            tabs: {
                initial: 1
            },
            slides: {
                autoplay: false,
                loop: false,
                fullscreenAPIEnabled: false,
            },
            controls: {
                video: {
                    layout: [
                        'play-pause',
                        'volume',
                        'progress-bar',
                        'timer',
                        'cc',
                        'dt',
                        'fullscreen',
                        'fullscreen-exit',
                        'video-volume-levels'
                    ],
                    display: 'show',
                    nonFullscreen: true,
                    playIconOverlay: 'pristine',
                },
            },
            thumbnails: {
                controls: false,
                previewOnHover: false,
            },
            video: {
                autoplay: (item.autoplay ?? false),
                muted: item.muted || false,
                loop: item.loop || false,
                unmuteOnFullscreen: item.unmuteOnFullscreen || true,
            },
            media: [],
        };
    }
}
